import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { SERVER_URL } from "../../../../api";
import {
	changeStatusDietType,
	deleteDietType,
	getDietTypes,
} from "../../../../api/dietType";
import { getNonEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
	buttonsStyle,
	dateFormatter,
} from "../../../components/tables/table";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";

function getData(dietTypes) {
	let data = [];
	for (let i = 0; i < dietTypes.length; ++i) {
		const elem = {};
		elem.name = getNonEmpty(dietTypes[i].fullName);
		elem.description = getNonEmpty(dietTypes[i].description);
		elem.imageURL = dietTypes[i].imageURL;
		elem.createdAt = dietTypes[i].createdAt;
		elem.id = dietTypes[i]._id;
		elem.active = dietTypes[i].active;
		data = data.concat(elem);
	}
	return data;
}

export default function DietTypesPage() {
	const [data, setData] = useState([]);
	const [dietTypeId, setDietTypeId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
	const [previewImage, setPreviewImage] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function imageFormatter(imageURL) {
		return imageURL && imageURL !== "" ? (
			<img
				src={SERVER_URL + "/" + imageURL}
				alt="dietType"
				style={{
					width: "50px",
					backgroundColor: "grey",
				}}
				onClick={() => {
					setPreviewImage(imageURL);
					setOpenPreviewDialog(true);
				}}
			/>
		) : (
			<div />
		);
	}

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => history.push("/edit-diet-type/" + cell)}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes("admin") && (
					<>
						<Tooltip title={elem?.active ? "Disable" : "Enable"}>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setDietTypeId(elem);
									setOpenConfirmDialog(1);
								}}
							>
								{elem?.active ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "red" }} />
								)}
							</Button>
						</Tooltip>
						<Tooltip title="Delete">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setDietTypeId(cell);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{
			dataField: "imageURL",
			text: "",
			headerAlign: "center",
			align: "center",
			formatter: imageFormatter,
		},
		{ dataField: "name", text: "Full name", sort: true },
		{ dataField: "description", text: "Description", sort: true },
		{
			dataField: "createdAt",
			text: "Created at",
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getDietTypes()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get diet types.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Diet types list">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/edit-diet-type")}
						>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={`Are you sure you want to ${
							dietTypeId?.active ? "disable" : "enable"
						} this diet type?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusDietType(
								dietTypeId.id,
								!dietTypeId?.active
							)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: `${
												dietTypeId?.active
													? "Disabled!"
													: "Enabled!"
											}`,
											customMessage: `Diet type ${
												dietTypeId?.active
													? "disabled"
													: "enabled"
											} successfully`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `Could not ${
											dietTypeId?.active
												? "disable"
												: "enable"
										} diet type.`,
									});
								});
						}}
					/>
					<ConfirmDialog
						title={
							"Are you sure you want to remove this diet type?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteDietType(dietTypeId)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "Deleted!",
											customMessage:
												"Diet type removed successfully.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not remove diet type.",
									});
								});
						}}
					/>
					<PreviewDialog
						title={"Preview image"}
						open={openPreviewDialog}
						setOpen={setOpenPreviewDialog}
						src={
							previewImage
								? `${SERVER_URL}/${previewImage}`
								: null
						}
					/>
				</CardBody>
			</Card>
		</>
	);
}
